<template>
  <transition name="fade">
    <div class="welfare" v-if="visible">
      <div class="welfare-shadow" @click="hideWelfarePopup"></div>
      <div class="welfare-main">
        <a
          href="javascript:;"
          class="welfare-main-close"
          @click="hideWelfarePopup"
        ></a>
        <div class="welfare-main-title">
          <p class="text">{{ letter.payWelfare }}</p>
        </div>
        <img
          class="game-popup-bg"
          v-if="gamePopupBg"
          :src="gamePopupBg"
          alt="game-popup-bg"
        />
        <ul class="main-list" v-if="welfareList.length > 0">
          <li
            class="main-list-item"
            @click="jumpWelfareLink(item.link, item.linkKey)"
            v-for="(item, index) in welfareList"
            :key="index"
          >
            <div class="item-cont">
              <img class="item-cont-ico" :src="item.ico" alt="item-cont-ico" />
              <p class="item-cont-text">
                {{ item.text[lang] || item.text[item.defaultLang] }}
              </p>
            </div>
            <em class="item-cont-go-ico"></em>
          </li>
        </ul>
        <div class="community" v-else>
          <p class="community-tip">{{ letter.voucherActivityNotBegin }}</p>
          <p class="community-tip">{{ letter.voucherGoCommunity }}</p>
          <ul class="community-list" v-if="communityList.length">
            <!-- 2023.11.13 产品/运营需求：斗罗3D东南亚、全球寻道大千、全球空之要塞社群跳转链接特殊处理 -->
            <template v-for="(item, index) in communityList">
              <li
                class="community-list-item"
                :style="{ backgroundColor: item.btnColor }"
                @click="jumpCommunityLink(item.link, item.linkKey)"
                v-if="showCommunityItem(item.linkKey)"
                :key="index"
              >
                <img class="item-ico" :src="item.ico" alt="item-ico" />
                <span class="item-text">
                  {{ item.text[lang] || item.text[defaultLang] }}
                </span>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import showWelfare from '@mixins/officialWebStore/showWelfare';
import globalConfig from '@utiles/officialStore/globalConfig';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV2';
import { sdkOpenLink } from '@utiles/officialStore/sdkCtrl';
import openActivity, { EVENT_LIST_ACTIVITY } from '@utiles/openActivity';
import {
  getGlobalGetGotoLink,
  getGlobalGetLinkParams
} from '@utiles/globalGetLink';
export default {
  name: 'WelfarePopup',
  mixins: [showWelfare],
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showActivityRedDot: true
    };
  },
  computed: {
    ...mapState({
      welfareBtnRecord: state => state.welfareBtnRecord,
      letter: state => state.letter,
      lang: state => state.lang
    }),
    ...mapGetters(['gameInfoConfig']),
    welfareList() {
      // 2024.08.21 星谕需求：rov,gnjoy.hk独有福利弹窗，后面确认全部放开可去掉
      if (+this.gameId === 371 && globalConfig.getMainHost() !== 'gnjoy.hk') {
        return [];
      }
      if (this.gameInfoConfig?.welfareConfig?.welfareList?.length) {
        return this.gameInfoConfig.welfareConfig.welfareList.filter(
          item => item.text[this.lang] || item.text[item.defaultLang]
        );
      } else {
        return [];
      }
    },
    communityList() {
      if (this.gameInfoConfig?.welfareConfig?.communityList?.length) {
        return this.gameInfoConfig.welfareConfig.communityList;
      } else {
        return [];
      }
    },
    gamePopupBg() {
      return this.gameInfoConfig?.popupGameBg || '';
    },
    defaultLang() {
      return this.gameInfoConfig?.defaultLang || '';
    }
  },
  methods: {
    hideWelfarePopup() {
      this.$emit('update:visible', false);
    },
    showCommunityItem(linkKey) {
      if (+this.gameId === 314) {
        if (
          (linkKey === 'lounge' && this.lang === 'ko-KR') ||
          (linkKey === 'discord' && this.lang !== 'ko-KR') ||
          linkKey === 'facebook'
        ) {
          return true;
        }
        return false;
      }
      if (+this.gameId === 303) {
        if (
          (linkKey === 'lounge' && this.lang === 'ko-KR') ||
          (linkKey === 'discord' && this.lang !== 'ko-KR')
        ) {
          return true;
        }
        return false;
      }
      return true;
    },
    jumpCommunityLink(link, linkKey) {
      // 2023.11.13 产品/运营需求：斗罗3D东南亚、全球寻道大千、全球空之要塞社群跳转链接特殊处理
      let reallyLink = link;
      if (
        +this.gameId === 274 &&
        this.lang === 'vi-VN' &&
        linkKey === 'facebook'
      ) {
        reallyLink = 'https://www.facebook.com/DauLaDaiLuc3D.VN';
      }
      if (
        +this.gameId === 339 &&
        this.lang === 'th-TH' &&
        linkKey === 'facebook'
      ) {
        reallyLink = 'https://www.facebook.com/profile.php?id=61552057842770';
      }
      if (
        +this.gameId === 314 &&
        this.lang === 'ko-KR' &&
        linkKey === 'facebook'
      ) {
        reallyLink = 'https://www.facebook.com/SkyFortressKR';
      }
      if (reallyLink) {
        sdkOpenLink({
          link: getGlobalGetGotoLink({ link: reallyLink })
        });
        clickButton({
          btnName: 'go_link',
          locationKey: locationType.eventList,
          otherParams: {
            link: reallyLink,
            name: linkKey || ''
          }
        });
      }
    },
    jumpWelfareLink(link, linkKey) {
      if (link) {
        openActivity(EVENT_LIST_ACTIVITY, link, {
          language: this.lang,
          appLanguage: this.lang,
          ...getGlobalGetLinkParams()
        });
        clickButton({
          btnName: 'go_link',
          locationKey: locationType.eventList,
          otherParams: {
            link: link,
            name: linkKey || ''
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/_dimen.scss';
.welfare {
  z-index: 9;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
  }
  &-main {
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -64%);
    width: 708px;
    box-sizing: border-box;
    background: #f5f5f5;
    border-radius: 10px;
    &-title {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 80px;
      .text {
        font-size: 30px;
        color: #333;
      }
    }
    &-close {
      position: absolute;
      right: 32px;
      top: 27px;
      background: url($tmslgImg + 'close.png') no-repeat;
      width: 28px;
      height: 28px;
      cursor: pointer;
    }
  }
  .main {
    &-list {
      padding: 0 20px;
      &-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        margin-bottom: 30px;
        background: #fff;
        padding: 13px;
        border-radius: 10px;
      }

      .item {
        &-cont {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          &-ico {
            margin-right: 13px;
            width: 94px;
            height: 83px;
          }
          &-text {
            font-size: 24px;
            color: #333;
          }
          &-go-ico {
            position: relative;
            width: 14px;
            height: 22px;
            background: url($tmslgImg + 'welfare-go-ico.png') no-repeat;
          }
        }
      }
    }
  }
  .community {
    padding: 0 20px;
    &-tip {
      font-size: 28px;
      color: #333;
      margin: 0 auto 20px;
      text-align: center;
    }
    &-list {
      display: flex;
      justify-content: space-evenly;
      margin: 82px auto 41px;
      width: 100%;
      flex-wrap: wrap;
      &-item {
        display: flex;
        min-width: 100px;
        justify-content: center;
        align-items: center;
        position: relative;
        padding: 13px;
        border-radius: 40px;
      }
      .item {
        display: flex;
        align-items: center;
        &-ico {
          margin-right: 13px;
          width: 44px;
        }
        &-text {
          font-size: 24px;
          color: #fff;
        }
      }
    }
  }
  .game-popup-bg {
    width: 100%;
    margin-bottom: 35px;
  }
}
@media screen and (orientation: landscape) {
  .welfare-main {
    width: $landscapePopupWidth;
  }
  .welfare-main-title {
    height: 61px;
    line-height: 61px;

    .text {
      font-size: 22px;
    }
  }
  .welfare .community-tip {
    font-size: 22px;
  }
  .welfare-main-close {
    position: absolute;
    right: 15px;
    top: 19px;
    background: url($tmslgImg + 'close.png') no-repeat;
    width: 23px;
    height: 23px;
    cursor: pointer;
    background-size: cover;
  }
  .welfare .community-list-item {
    cursor: pointer;
  }
}
</style>
